import { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import DashboardHeaderSection from '../components/common/dashboardheader/DashboardHeader';
import ReviewsLeaderboardPage from '../components/reviewsLeaderboard/ReviewsLeaderboardPage';

export default function ReviewsLeaderboard() {
  useEffect(() => { document.title = 'Reviews Leaderboard | Meesha'; }, []);
  return (
    <>
      <CssBaseline />
      <DashboardHeaderSection hideSearch={true} />
      <ReviewsLeaderboardPage />
    </>
  );
}
